import { useEffect } from "react";
import ShadowCard from "components/common/cards/ShadowCard";
import BlueSwitchCheckboxInput from "components/common/inputs/BlueSwitchCheckboxInput";
import { useForm } from "contexts/FormContext";
import CnFormAddressFields from "./CnFormAddressFields";

export default function CnFormAccountAddressSection({
  states = [],
  cities = [],
  counties = [],
  data,
  checkboxLabel,
}) {
  const { form, inputOnChange, validateForm } = useForm();

  useEffect(() => {
    validateForm();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    form.BillState,
    form.BillCity,
    form.BillCounty,
    form.BillStreet1,
    form.BillStreet2,
    form.AddressIsTheSame,
  ]);

  const {
    title,
    text1,
    text2,
    text3,
    inputModelArray: {
      0: {
        fields: { listArray },
      },
    },
  } = data.fields;

  return (
    <ShadowCard label={title}>
      <div className="form-max flex-20 column" id="account-address-section">
        <p className="address-country">
          {text1}
          <strong>{text2}</strong>
        </p>
        <BlueSwitchCheckboxInput
          inputId="AddressIsTheSame"
          inputName="AddressIsTheSame"
          inputAriaLabel="AddressIsTheSame"
          inputChecked={form.AddressIsTheSame}
          inputOnChange={inputOnChange}
          label={checkboxLabel || text3}
          required
        />
        {!form.AddressIsTheSame && (
          <CnFormAddressFields
            addressType="Bill"
            states={states}
            cities={cities}
            counties={counties}
            listArray={listArray}
          />
        )}
      </div>
    </ShadowCard>
  );
}
